import {InjectionToken} from '@angular/core';
import { Observable } from 'rxjs';

export interface DataRequirements {
    sentMail(mail): Observable<any>;
    checkMail(token): Observable<any>;
    resetPassword(token,body): Observable<any>;
}

export const DataRequirementsInjectionToken = new InjectionToken<DataRequirements>('forgot-password Data Requirements')
